export default {
  title: 'Relations Sugar',
  sb_list_title: 'Sugar Babies Disponibles',
  sd_list_title: 'Sugar Daddies Disponibles',
  no_sb_profiles: 'Aucun profil Sugar Baby à afficher pour le moment.',
  no_sd_profiles: 'Aucun profil Sugar Daddy à afficher pour le moment.',
  no_sb_profiles_found: 'Aucun profil Sugar Baby trouvé correspondant à vos critères.',
  no_sd_profiles_found: 'Aucun profil Sugar Daddy trouvé correspondant à vos critères.',
  error_invalid_role: 'Votre rôle actuel ne permet pas d\'accéder à cette section ou vue.',
  error_profile_not_found: 'Profil non trouvé ou accès refusé.',
  error_profile_id_missing: 'ID de profil manquant.',
  // Teaser Page Keys
  teaser_title: 'Débloquez un monde d\'opportunités exclusives',
  teaser_subtitle: 'Aperçu des profils d\'exception. Abonnez-vous pour un accès complet à notre communauté Sugar.',
  teaser_no_profiles: 'Aucun aperçu de profil disponible pour le moment. Revenez bientôt !',
  teaser_cta_title: 'Prêt(e) à vivre l\'expérience Pink Paradise ?',
  teaser_cta_text: 'Accédez à tous les profils, discutez sans limites et trouvez votre partenaire idéal en devenant membre Regular ou VIP.',
  // Detail Page Sections
  section_description: 'À propos',
  section_lifestyle: 'Style de vie & Intérêts',
  section_expectations: 'Attentes de l\'arrangement',
  section_contribution: 'Ce que j\'apporte',
  section_boundaries: 'Mes limites',
  section_offered_arrangement: 'Ce que je propose',
  // Detail Page Fields
  age_range: 'Tranche d\'âge',
  profession: 'Profession',
  expectation_type: 'Type d\'arrangement',
  expectation_frequency: 'Fréquence souhaitée',
  expectation_platonic: 'Platonique possible',
  expectation_financial: 'Détails soutien financier',
  offered_support_type: 'Type de soutien',
  offered_mentoring_field: 'Domaine de mentorat',
  offered_arrangement_type: 'Type d\'arrangement',
  // Badges
  badge_verified_sd: 'SD Vérifié',
  badge_revenue_verified: 'Revenus Vérifiés', // Si utilisé
  // Buttons
  button_contact: 'Contacter',
  button_create_sb_profile: 'Créer mon Profil Sugar Baby',
  button_edit_sb_profile: 'Modifier mon Profil Sugar Baby',
  button_create_sd_profile: 'Créer mon Profil Sugar Daddy',
  button_edit_sd_profile: 'Modifier mon Profil Sugar Daddy',
  // Titles Form Pages
  title_create_sb_profile: 'Créer votre Profil Sugar Baby',
  title_edit_sb_profile: 'Modifier votre Profil Sugar Baby',
  title_create_sd_profile: 'Créer votre Profil Sugar Daddy',
  title_edit_sd_profile: 'Modifier votre Profil Sugar Daddy',
  // Tags (Namespace: tags.subnamespace.key)
  tags: {
    lifestyle: {
      studies: 'Études', professional: 'Professionnel', hobbies: 'Hobbies', travel: 'Voyages', gastronomy: 'Gastronomie', artsCulture: 'Arts & Culture', luxury: 'Luxe', sports: 'Sports', wellness: 'Bien-être'
    },
    arrangement: {
      mentorship: 'Mentorat', financialSupport: 'Soutien financier', experiences: 'Expériences', networking: 'Réseautage', shortTerm: 'Court terme', longTerm: 'Long terme', platonic: 'Platonique', discreet: 'Discret', public_limited: 'Public (limité)', eventsCompanion: 'Compagnie événements', regularDates: 'Rendez-vous réguliers'
    },
    frequency: {
      occasional: 'Occasionnelle', regular: 'Régulière', negotiable: 'À discuter'
    },
    financial: {
       studies: 'Études', project: 'Projet', allowance: 'Allocation', gifts: 'Cadeaux', negotiable: 'À discuter'
    },
    sd_support: {
       mentorship: 'Mentorat', generousSupport: 'Soutien généreux', needsBasedSupport: 'Basé sur besoins', gifts: 'Cadeaux', travel: 'Voyages', eventsAccess: 'Accès événements', networkingAccess: 'Accès réseau', sharedExperiences: 'Expériences partagées'
    }
  }
}; 